import React, { useState, useRef, useEffect } from 'react';
import TeacherPanel from '../panel/TeacherPanel';
import "../styles/TeacherComposeNotification.css";
import api from "../../../api/api";

const TeacherComposeNotification = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const fileInputRef = useRef(null);

  const [classes, setClasses] = useState([]);
  const [sections, setSections] = useState([]);
  const [students, setStudents] = useState([]);

  const [selectedClass, setSelectedClass] = useState("");
  const [selectedSections, setSelectedSections] = useState([]);
  const [selectedStudents, setSelectedStudents] = useState([]);

  const [formData, setFormData] = useState({
    targetAudience: 'All Students',
    title: '',
    message: '',
    attachment: null,
  });

  // Fetch classes on load
  useEffect(() => {
    api.get('/api/teacher-notifications/classes')
  .then(res => setClasses(res.data))
  .catch(err => console.error(err));
  }, []);

  // Fetch sections when a class is selected
  useEffect(() => {
    if (!selectedClass) return;
api.get(`/api/teacher-notifications/sections?classId=${selectedClass}`)
  .then(res => setSections(res.data))
  .catch(err => console.error(err));
  }, [selectedClass]);

  // Fetch students when a section is selected (for selected audience)
  useEffect(() => {
    if (formData.targetAudience !== 'Selected Students' || !selectedClass || selectedSections.length === 0) {
      setStudents([]);
      return;
    }

    Promise.all(selectedSections.map(section =>
      api.get(`/api/teacher-notifications/students?classId=${selectedClass}&section=${section}`)
  .then(res => res.data)
    ))
    .then(results => {
      const allStudents = results.flat();
      setStudents(allStudents);
    })
    .catch(err => console.error(err));
  }, [formData.targetAudience, selectedClass, selectedSections]);

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    if (type === 'file') {
      setFormData(prev => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData(prev => ({ ...prev, [name]: value }));
    }
  };

  const handleSectionChange = (e) => {
    const { value, checked } = e.target;
    setSelectedSections(prev => checked ? [...prev, value] : prev.filter(s => s !== value));
  };

  const handleStudentChange = (studentId) => {
    setSelectedStudents(prev =>
      prev.includes(studentId)
        ? prev.filter(s => s !== studentId)
        : [...prev, studentId]
    );
  };

const handleSubmit = async (e) => {
  e.preventDefault();
  if (!formData.title.trim() || !formData.message.trim()) {
    alert('Please fill all required fields!');
    return;
  }

  try {
    const payload = new FormData();
    payload.append('title', formData.title);
    payload.append('message', formData.message);
    payload.append('targetAudience', formData.targetAudience);
    payload.append('classIds', JSON.stringify([selectedClass]));  // ✅ FIXED
    payload.append('sections', JSON.stringify(selectedSections));
    payload.append('studentIds', JSON.stringify(selectedStudents));
    if (formData.attachment) payload.append('attachment', formData.attachment);

   const res = await api.post("/api/teacher-notifications", payload, {
  headers: {
    "Content-Type": "multipart/form-data"
  }
});

const data = res.data;

alert(`✅ Notification Sent Successfully! ID: ${data.notificationId}`);

    setFormData({ targetAudience: 'All Students', title: '', message: '', attachment: null });
    setSelectedClass("");
    setSelectedSections([]);
    setSelectedStudents([]);
    if (fileInputRef.current) fileInputRef.current.value = null;
  } catch (err) {
    console.error(err);
    alert('❌ Error sending notification: ' + err.message);
  }
};


  return (
    <div>
      <TeacherPanel onToggle={setIsSidebarCollapsed} />
      <div className={`teacher-notification-main-content ${isSidebarCollapsed ? 'collapsed' : ''}`}>
        <h1 style={{ margin: '20px 0' }}>Teacher Notification Composer</h1>
        <form className="teacher-notification-form" onSubmit={handleSubmit}>
          <label>
            Target Audience:
            <select name="targetAudience" value={formData.targetAudience} onChange={handleChange}>
              <option value="All Students">All Students</option>
              <option value="Selected Students">Selected Students</option>
            </select>
          </label>

          <label>
            Class:
            <select value={selectedClass} onChange={(e) => setSelectedClass(e.target.value)}>
              <option value="">Select Class</option>
              {classes.map(c => <option key={c.id} value={c.id}>{c.name}</option>)}
            </select>
          </label>

{sections.length > 0 && (
  <div className="sections-container">
    <h3>Sections</h3>
    <table className="sections-table">
      <thead>
        <tr>
          <th>Section Name</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {sections.map((s, index) => (
          <tr key={index}>
            <td>{s.section_name || s.name || s}</td>
            <td>
              <input
                type="checkbox"
                value={s.section_name || s.name || s}
                checked={selectedSections.includes(s.section_name || s.name || s)}
                onChange={handleSectionChange}
              />
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
)}


          {formData.targetAudience === 'Selected Students' && students.length > 0 && (
            <div>
              <strong>Students:</strong>
              {students.map(s => (
                <label key={s.id}>
                  <input
                    type="checkbox"
                    checked={selectedStudents.includes(s.id)}
                    onChange={() => handleStudentChange(s.id)}
                  />
                  {s.name}
                </label>
              ))}
            </div>
          )}

          <label>
            Notification Title:
            <input type="text" name="title" value={formData.title} onChange={handleChange} required />
          </label>

          <label>
            Notification Message:
            <textarea name="message" value={formData.message} onChange={handleChange} rows={6} required />
          </label>

          <label>
            Attach File:
            <input type="file" name="attachment" ref={fileInputRef} onChange={handleChange} />
          </label>

          <button type="submit" className="teacher-send-btn">Send Notification</button>
        </form>
      </div>
    </div>
  );
};

export default TeacherComposeNotification;
